// extracted by mini-css-extract-plugin
export var carrierNotice = "_hs-5";
export var carrierNoticePlaceholder = "_hs-6";
export var deliveryRow = "_hs-c";
export var fixedHeight = "_hs-4";
export var freightLogo = "_hs-b";
export var fullWidth = "_hs-3";
export var priceColumn = "_hs-7";
export var radioSelected = "_hs-9";
export var radioUnselected = "_hs-8";
export var selectedOption = "_hs-2";
export var selectedOptionContainer = "_hs-1";
export var selection = "_hs-0";
export var tallSkeletonText = "_hs-a";